import { Type } from '@angular/core';
import { BaseService } from '../base.service';

/**
 * Types de sérialisation URL d'un filtre :
 * - `id[]`  : tableau d'entités (objets `{ _id, … }` ou ids) → seuls les `_id` vont dans l'URL, restaurés en ids bruts.
 * - `range` : `{ comparison, min, max }` produit par `select-between` (date ou nombre) → `comparison,min,max`.
 */
export type UrlFilterType = 'string' | 'number' | 'boolean' | 'string[]' | 'id[]' | 'range';

export type FilterFieldType = 'text' | 'number' | 'boolean' | 'option' | 'option[]' | 'entity[]' | 'value[]' | 'range';

export interface FilterFieldSpec {
  type: FilterFieldType;
  control?: string; // nom du contrôle, défaut = clé API
  form?: string; // clé du form, défaut 'standardForm' ; pour 'range' = le form de plage
  // Champ du composant de filtre tenant la liste d'objets du contrôle :
  // - 'option'/'option[]', ou un scalaire ('boolean'…) présenté par un select : {value,label}[] retrouvés par `value`,
  //   l'API reçoit `value` typé ;
  // - 'entity[]' statique (liste chargée par le composant, pas d'autocomplete) : entités retrouvées par `_id`,
  //   sans requête by-ids.
  options?: string;
  wrap?: 'array'; // 'option' émise en [value]
  valueField?: string; // 'value[]'
  resolve?: { service: Type<BaseService<any>>; key?: string; displayProperty: string; map?: (item: any) => any };
}

export type FilterSchema = Record<string, FilterFieldSpec>;

const URL_TYPE_BY_FIELD_TYPE = {
  text: 'string',
  number: 'number',
  boolean: 'boolean',
  option: 'string',
  'option[]': 'string[]',
  'value[]': 'string[]',
  'entity[]': 'id[]',
  range: 'range',
} satisfies Record<FilterFieldType, UrlFilterType>;

// Une 'option' émise en [value] (`wrap: 'array'`) doit être relue avec getAll() : get() rendrait une chaîne,
// que les @ArrayFilter du back ignorent sans erreur (PRED-3281).
export const toUrlFilterType = (spec: FilterFieldSpec): UrlFilterType =>
  spec.wrap === 'array' ? 'string[]' : URL_TYPE_BY_FIELD_TYPE[spec.type];
